import { LogJsError } from '@/service/monitor';

// 使用示例
// 立即执行
// executeWhenReady(function() {
//   console.log('Function executed immediately.');
// }, true);
// 在DOM加载完成后执行
// executeWhenReady(function() {
//   console.log('Function executed after DOMContentLoaded.');
// });

export function executeCallbackWithTryCatch(callback) {
  try {
    callback();
  } catch (error) {
    console.log(error);
    LogJsError({
      em: error.message,
      es: error.stack
    });
  }
}

export function executeWhenReady(callback, immediate = false) {
  if (immediate) {
    executeCallbackWithTryCatch(callback);
  } else {
    const onDOMContentLoaded = () => {
      executeCallbackWithTryCatch(callback);
      document.removeEventListener('DOMContentLoaded', onDOMContentLoaded);
    }

    const onReadyStateChange = () => {
      if (document.readyState === 'complete') {
        executeCallbackWithTryCatch(callback);
        document.onreadystatechange = null;
      }
    }

    if (document.readyState === 'loading') {
      if ('addEventListener' in document) {
        document.addEventListener('DOMContentLoaded', onDOMContentLoaded);
      } else {
        (document as any).onreadystatechange = onReadyStateChange;
      }
    } else {
      executeCallbackWithTryCatch(callback);
    }
  }
}

export function executeWhenBodyReady(callback) {
  if (window?.document?.body) {
    executeCallbackWithTryCatch(callback);
  } else {
    const docCallback = () => {
      if (window?.document?.readyState === 'interactive' || window?.document?.readyState === 'complete') {
        window?.document?.removeEventListener('readystatechange', docCallback);
        window?.document?.removeEventListener('DOMContentLoaded', docCallback);
        executeCallbackWithTryCatch(callback);
      }
    };
    window?.document?.addEventListener('readystatechange', docCallback);
    window?.document?.addEventListener('DOMContentLoaded', docCallback);
  }
}
